export const availableLocales = [
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'ja',
  'pt',
  'sv',
  'zh-Hans',
  'it',
] as const;

export type Language = (typeof availableLocales)[number];

export const FALLBACK_LANGUAGE: Language = 'en';
